import utilCommon from './utilCommon'
import { DATA_SOURCE_FC } from './enums';

export function authHeader() {
    let header = {}

    if (utilCommon.getSession('refreshToken') && !utilCommon.getSession('accessToken')) {
        header.refreshToken = utilCommon.getSession('refreshToken')
    }

    if (utilCommon.getSession('accessToken')) {
        header.accessToken = utilCommon.getSession('accessToken')
    }

    header['X-Data-Source'] = DATA_SOURCE_FC;
    header['X-Remote-Source'] = Number(sessionStorage.getItem('remoteSource'));
    header['X-Fingerprint'] = window.visitorId || '';

    return header
}

export default authHeader;
